import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import CopyIcon from "@material-ui/icons/FileCopy";
import withStyles from "@material-ui/core/styles/withStyles";
import OSSTooltip from "../OSSTooltip/OSSTooltip";
import { CopyToClipboard } from "react-copy-to-clipboard";

const styles = theme => ({
  copyIcon: {
    fontSize: theme.typography.pxToRem(16)
  }
});

const OSSCopyButton = ({
  classes,
  className,
  text = "",
  onCopy = () => {},
  preCopyTooltip = "Copy",
  postCopyTooltip = "Copied!",
  TooltipProps = {},
  Icon = <CopyIcon color="inherit" classes={{ root: classes.copyIcon }} />
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    onCopy();
  };

  return (
    <OSSTooltip
      title={<small>{copied ? postCopyTooltip : preCopyTooltip}</small>}
      onClose={() => setCopied(false)}
      TransitionProps={{
        timeout: 0
      }}
      {...TooltipProps}
    >
      <CopyToClipboard text={text} onCopy={handleCopy}>
        <IconButton classes={{ root: className }}>{Icon}</IconButton>
      </CopyToClipboard>
    </OSSTooltip>
  );
};

export default withStyles(styles)(OSSCopyButton);
